import React, { Component } from 'react';
import { Loader, List, Pagination, Dimmer, Segment, Button, Table } from 'semantic-ui-react';
import _ from 'lodash';
import Page from '../../components/Page';
import moment from 'moment';
import { connect } from 'react-redux';
import { post, toWapi } from '../../util/api';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import cs from 'classnames';

const ICONS = {
	incoming: 'share alternate square',
	outgoing: 'caret square right',
	error: 'exclamation circle',
	message: 'envelope square',
	status: 'whatsapp square',
	default: 'square',
};
const COLORS = {
	incoming: 'blue',
	outgoing: 'orange',
	error: 'red',
	default: 'green',
};

function useWapi(url, token) {
	const [data, setData] = React.useState(null);
	React.useEffect(() => {
		let cancel;
		toWapi(url, token)
			.then((data) => {
				if (!cancel) setData(data);
			})
			.catch((error) => {
				if (!cancel) setData({ error });
			});
		return () => {
			cancel = true;
		};
	}, [url, token]);
	return { loading: data === null, data, error: data && data.error };
}

function LogsTable(props) {
	//const [list, setList] = React.useState();
	//const [loading, setLoading] = React.useState(true);
	const [page, setPage] = React.useState(1);
	//const [maxPage, setMaxPage] = React.useState(0);
	const [sort] = React.useState('');
	const [type, setType] = React.useState('');
	const [selected, setSelected] = React.useState({});
	const { data, loading } = useWapi(`/api/${props.pid}/logs?page=${page}&type=${type}&order=${sort}`, props.token, type);
	const { list, maxPage } = React.useMemo(() => {
		let body = data && data.data && data.data.data;
		if (body) {
			body.maxPage = Math.ceil(body.count / 50);
		}
		return body || {};
	}, [data]);
	let current = !selected.id && list ? list[0] : selected;
	return (
		<div
			css={`
				display: flex;
				flex: 1;
				margin: 0 !important;
				max-width: 100%;
				> div {
					flex: 1;
					max-height: 100%;
					padding: 14px;
					overflow: auto;

					display: flex;
					flex-direction: column;
				}
				.list {
					flex: 1;
					overflow: auto;
					border-radius: 6px;
				}

				.log-body {
					&.success {
						//color: #009687 !important;
					}
					display: flex;
					align-items: center;
					.type {
						display: inline-block;
						width: 120px;
						color: #333;
					}
					.conv {
						font-size: 11px;
					}
				}
				.log-id {
					display: inline-block;
					margin-right: 5px;
					width: 50px;
					font-size: 11px;
				}
				.response {
					margin-left: auto;
				}
				.pager {
					text-align: center;
				}
			`}
		>
			<div>
				<div className="control">
					<Button.Group>
						<Button active={type === ''} onClick={() => setType('')}>
							All
						</Button>
						<Button active={type === 'incoming'} onClick={() => setType('incoming')}>
							Incoming
						</Button>
						<Button active={type === 'outgoing'} onClick={() => setType('outgoing')}>
							Outgoing
						</Button>
						<Button active={type === 'error'} onClick={() => setType('error')}>
							Error
						</Button>
					</Button.Group>
				</div>
				<Dimmer.Dimmable as={List} selection verticalAlign="middle" dimmed={loading}>
					<Dimmer active={loading}>
						<Loader>Loading</Loader>
					</Dimmer>
					{_.map(list, (it) => {
						let { type, data } = it;
						let body = (data && data.body) || {};
						let subtype = type === 'outgoing' ? body.type || type : type;
						let icontype = subtype;
						if (data.path === '/sendMessage') {
							icontype = 'message';
						}
						let isIncoming = type === 'incoming';
						let statusCode = isIncoming ? it.data && it.data.statusCode : it.data.response && it.data.response.statusCode;
						let success = statusCode === 200;
						let conv = body.conversation || body.to_number || body.status;
						if (it.data.path === '/status') conv = _.get(it, 'data.response.status.state.state');
						if (subtype === 'error') conv = body.message;
						return (
							<List.Item key={it.id} active={current === it} onClick={() => setSelected(it)}>
								<List.Icon name={ICONS[icontype] || ICONS.default} color={COLORS[subtype] || COLORS.default} verticalAlign="middle" />
								<List.Content>
									<div className={cs('log-body', { success })}>
										<span className="log-id">{it.id}</span>
										<span className="type">{isIncoming ? it.data && it.data.path : body.type}</span>
										{conv && <span className="conv">[{conv}]</span>}
										<List.Header></List.Header>
										{statusCode && statusCode !== 200 && <span className="response">{statusCode}</span>}
									</div>
								</List.Content>
							</List.Item>
						);
					})}
				</Dimmer.Dimmable>

				{maxPage ? (
					<div className="pager">
						<Pagination
							boundaryRange={1}
							activePage={page}
							onPageChange={(e, { activePage }) => setPage(activePage)}
							ellipsisItem={null}
							firstItem={null}
							lastItem={null}
							siblingRange={1}
							totalPages={maxPage}
						/>
					</div>
				) : null}
			</div>
			<div>
				<Segment
					css={`
						padding: 5px !important;
					`}
				>
					{console.log('selected', selected)}
					{selected ? (
						<Table basic celled>
							<Table.Body>
								<Table.Row>
									<Table.Cell>Event Id</Table.Cell>
									<Table.Cell>{selected.id}</Table.Cell>
								</Table.Row>
								<Table.Row>
									<Table.Cell>Date</Table.Cell>
									<Table.Cell>{moment(selected.created_at).format('LLL')}</Table.Cell>
								</Table.Row>
								<Table.Row>
									<Table.Cell>Phone Id</Table.Cell>
									<Table.Cell>{selected.phone}</Table.Cell>
								</Table.Row>
							</Table.Body>
						</Table>
					) : (
						<Table basic celled>
							<Table.Body>
								<Table.Row>NO DATA</Table.Row>
							</Table.Body>
						</Table>
					)}
					{selected && selected.id ? (
						<pre
							css={`
								max-width: 100%;
								overflow: auto;
								margin: 0;
							`}
						>
							{JSON.stringify(current.data, null, 2)}
						</pre>
					) : null}
				</Segment>
			</div>
		</div>
	);
}

class Logs extends Component {
	componentDidMount() {
		var urlParams = new URLSearchParams(window.location.search);
		let uid = urlParams.get('uid') || '';
		let email = urlParams.get('email') || '';
		/* 	if (email) {
			post('/maytapi/user', { email }).then(data => {
				if (data.data.success) {
					uid = data.data.user.id;
					post('/maytapi/uproduct', {
						uid,
					}).then(data => {
						if (data.data.success) {
							this.setState({ uproduct: data, loading: false });
						} else {
							this.setState({ loading: false });
						}
					});
				} else {
					console.log('e');
				}
			});
		} else {
			post('/maytapi/uproduct', {
				uid,
			}).then(data => {
				if (data.data.success) {
					this.setState({ uproduct: data, loading: false });
				} else {
					this.setState({ loading: false });
				}
			});
		} */

		post('/maytapi/admin/userproduct', {
			uid,
			email,
		}).then((data) => {
			if (data.data.success) {
				this.setState({ uproduct: data, token: data.data.token, loading: false });
			} else {
				this.setState({ loading: false, error: true });
			}
		});
	}
	state = {
		loading: true,
		error: false,
	};
	get token() {
		let product = this.state.uproduct.data.product;
		return (product && product.settings && product.settings.wapi_token) || this.state.token;
	}

	get pid() {
		let product = this.state.uproduct.data.product;
		return product && product.id;
	}

	toWapi = (path, data) => {
		return toWapi(`/api/${this.pid}${path}`, this.token, data);
	};

	render() {
		if (this.state.loading)
			return (
				<Segment attached="bottom">
					<Page.Loader></Page.Loader>
				</Segment>
			);
		if (this.state.error) {
			return <Segment attached="bottom">No User</Segment>;
		}
		return (
			<Segment
				attached="bottom"
				css={`
					max-height: 95%;
					padding: 0 !important;
				`}
			>
				<LogsTable toWapi={this.toWapi} token={this.token} pid={this.pid} />
			</Segment>
		);
	}
}

export default connect((state) => ({ user: state.access.user.loggedUserObj, product: state.product.maytapi }))(Logs);
